/**
 * @module KUP
 * @param  {Object} $ jQuery-Objekt
 * @return {Null}
 */
(function($) {
    "use strict";

    /**
     * Global bereit gestelltes Objekt, das durch Module erweitert werden
     * kann und welches die Grundfunktionalität der Anwendung bereit stellt.
     *
     * @class  KUP
     * @constructor
     */
    var KUP = (function() {
        /**
         * Initialisierung der Anwendung.
         *
         * @method init
         * @return {Null}
         */
        function init() {
            AOS.init();

            // Active-State auf mobilen Devices nutzen
            if("ontouchstart" in document.documentElement) {
                document.addEventListener("touchstart", function() {}, true);
            }

            // Initialisierung von KUP Modulen
            initModules();
        }

        /**
         * Es werden alle Module initialisiert, die über die Funktion `init`
         * verfügen. Um eine Initialisierung zu verhindern, wird bei den entsprechenden
         * Modulen für die Init-Funktion `_init` verwendet.
         *
         * @private
         * @method initModules
         * @return {Null}
         */
        function initModules() {
            var module;
            for(module in KUP) {
                if(
                    KUP.hasOwnProperty(module) &&
                    typeof KUP[module].init === "function"
                ) {
                    KUP[module].init();
                }
            }
        }

        return {
            init: init
        };
    })();

    $(document).ready(function() {
        KUP.init();
    });

    // Reinit modules because of using ajax with geysir if user is logged in
    if ( $('body').hasClass('user-logged-in') ) {
        Drupal.behaviors.custom_behavior = {
            attach: function (context) {
                $(once('custom-behavior', window))
                  .on('dialog:afterclose', function () {
                    setTimeout(function() {
                      KUP.init();
                      $('.use-ajax.geysir-button').attr('data-once', 'ajax');
                    }, 200);
                  });

                // $(window)
                //     .once('custom-behavior')
                //     .on('dialog:afterclose', function () {
                //         setTimeout(function() {
                //             KUP.init();
                //             $('.use-ajax.geysir-button').attr('data-once', 'ajax');
                //         }, 200);
                //
                //     });
            }
        };
    }

    // Im globalen Kontext bereitstellen
    window.KUP = KUP;
})(jQuery);
